import { render } from "./InventorySourceType.vue?vue&type=template&id=8dfa1bb6&scoped=true"
import script from "./InventorySourceType.vue?vue&type=script&lang=js"
export * from "./InventorySourceType.vue?vue&type=script&lang=js"

import "./InventorySourceType.vue?vue&type=style&index=0&id=8dfa1bb6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dfa1bb6"]])

export default __exports__